import {
  LearningBudgetService,
  UpdateTeamBudgetAmountOpts,
} from '@/services/learning-budget';
import { ApiReactMutationOptions } from '@/types/api';
import { ApiLearningBudgetTransactionsDigestResponse } from '@/types/learning-budget';
import { useMutation } from '@tanstack/react-query';

export function useTeamLearningBudgetMutation(
  options?: ApiReactMutationOptions<
    ApiLearningBudgetTransactionsDigestResponse,
    UpdateTeamBudgetAmountOpts
  >,
) {
  return useMutation({
    mutationKey: [LearningBudgetService.PATH],
    mutationFn: LearningBudgetService.updateTeamBudgetAmount,
    ...options,
  });
}
